import { render, staticRenderFns } from "./EditTestbuy.vue?vue&type=template&id=08794f26"
import script from "./EditTestbuy.vue?vue&type=script&lang=js"
export * from "./EditTestbuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports